export default {
  namespaced: true,

  getters: {
    enabled(state, getters, rootState, rootGetters) {
      if (!rootGetters['builder/field/enabled']) {
        return false;
      }

      return true;
    },

    required(state, getters) {
      return getters.enabled;
    },

    label(state, getters, rootState, rootGetters) {
      return (key) => {
        if (!key) {
          throw new Error('Type is blank!');
        }

        const config = rootGetters['builder/config'];
        const { types } = config.entities.fields;
        const type = types[key];

        if (!type) {
          throw new Error(`Invalid type: ${key}`);
        }

        return type.label;
      };
    },

    choices(state, getters, rootState, rootGetters) {
      const config = rootGetters['builder/config'];

      if (
        !config ||
        !config.entities ||
        !config.entities.fields
      ) {
        return [];
      }

      const choices = config.entities.fields.types;

      if (!choices || !Object.keys(choices).length) {
        return [];
      }

      return Object.keys(choices).map((choiceKey) => ({
        value: choiceKey,
        label: choices[choiceKey].label,
      }));
    },
  },
};
